module.exports = __webpack_public_path__ + "static/media/sidebar-2.c037e112.jpg";